import { CustomersRoute, OnboardingRoute, PackagesRoute } from '../config/routePaths';

type RoleLike = { name?: string } | null | undefined;

const ONBOARDING_ROLES = ['Overlord', 'Administrator'];

/** An admin of a courier that hasn't been through the setup wizard yet. */
export const needsOnboarding = (
  roles: RoleLike[] | null | undefined,
  onboardingStatus: string | null | undefined
): boolean =>
  onboardingStatus === 'NOT_STARTED' &&
  (roles || []).some((role) => ONBOARDING_ROLES.includes(role?.name || ''));

/**
 * Where a sign-in lands. Shared by Auth and OnboardingRedirect so a new
 * courier goes straight to the wizard instead of hopping through pages that
 * each redirect it onwards.
 */
export const getPostLoginRoute = ({
  roles,
  onboardingStatus,
  from,
}: {
  roles: RoleLike[] | null | undefined;
  onboardingStatus: string | null | undefined;
  from?: string;
}): string => {
  if (needsOnboarding(roles, onboardingStatus)) return OnboardingRoute;
  if (from) return from;
  if ((roles || []).some((role) => role?.name === 'Limited Cashier')) return PackagesRoute;
  return CustomersRoute;
};
